export function setOperators(operators) {
  return {
    type: 'SET_ALL_OPERATORS',
    payload: operators
  };
}

export function setNotificationsCount(notificationInfo) {
  return {
    type: 'SET_NOTIFICATION_COUNT',
    payload: notificationInfo
  };
}

export function setNotificationOpened(data) {
  return {
    type: 'SET_NOTIFICATION_OPENED',
    payload: data
  };
}

export function setCommentOpened(payload) {
  return {
    type: 'OPEN_COMMENTS',
    payload
  };
}

export function setCommentClosed() {
  return {
    type: 'CLOSE_COMMENTS'
  };
}

/*
 *
 * New pending on-boarding filters
 *
 * */
export function setRequestFilters(filters, sorting, page, pageSize) {
  return {
    type: 'REQUEST_FILTERS_SET',
    payload: {
      filters,
      sorting,
      page,
      pageSize
    }
  };
}
export function resetRequestFilters() {
  return {
    type: 'REQUEST_FILTERS_RESET'
  };
}

export function setPoOpenChat(openChat) {
  return {
    type: 'PO_SET_OPEN_CHAT',
    payload: openChat
  };
}

export function setChatOpened(data) {
  return {
    type: 'SET_LAST_READ_OF_CHAT',
    payload: data
  };
}
